export default {
    //R
    account:{
        /*=== add-label.vue ====*/
        trading_account_label: "Label has been successfully added to your Trading Account.",
        ok: "OK",
        add_account_label: "Add Account Label",
        trading_account: "Trading Account",
        select_trading_id: "Select Trading ID",
        label: "Label",
        alpha_numeric_characters : "Assign a label to your account: (Alpha numeric upto 15 characters)",
        apply: "Apply",
        cancel: "Cancel",
        
        /*=== change-acct-leverage.vue ====*/
        request_change_laverage: "We have received your request to change the leverage of your trading ID",
        from :"from",
        to :"to",
        confirm_mail_id:"To confirm, kindly click on the confirmation link sent to your registered e-mail ID.",
        leverage_successfully_change:"Change leverage request processed successfully",
        change_account_leverage:"Change Account Leverage",
        select_trading_account :"Select Trading Account",
        existing_leverage :"Existing Leverage",
        new_leverage :"New Leverage",
        select_new_leverage :"Select new leverage",
        change_leverage:"Change Leverage",
        account_leverage_reduced :"If account leverage is reduced from the current leverage, it will increase the used margin on your open trades (if any).",
        
        /*=== create-account.vue ====*/
        mandatory_complete_KYC:"It's mandatory to complete KYC prior to create more then one Live account.",
        submit_proof_address:"Please submit a proof of address using a support ticket ",
        click_here:"Click here",
        email_to: "or email to",
        contactus_aaafx_com :"contactus{'@'}aaafx.com",
        following_address_Proofs: "The following Address Proofs are accepted:",
        utility_bill: "Utility Bill",
        bank_statement: "Bank Statement",
        government_issued:"Government-Issued Tax Document",
        note:"Note",
        proof_of_address:"The proof of address is required to be no older than 4 months.",
        account :"Account",
        select_platform:"Select Platform",
        select_account_type:"Select Account Type",
        connect_your_account:"Do you want to connect your account to ZuluTrade?",
        select_leverage:"Select Leverage",
        select_account_base_currency:"Select Account Base currency",
        select_currency:"Select Currency",
        Password:"Password",
        minimum_password_length5:"The minimum password length is 5 characters and must contain at least 1 lowercase letter, 1 capital letter 1 number and 1 special character.",
        minimum_password_length8:"The minimum password length is 8 characters and must contain at least 1 lowercase letter, 1 capital letter 1 number and 1 special character.",
        spcl_characters:"# of characters",
        lowercase_letter:"Lowercase letter",
        capital_letter:"Capital letter",
        number: "Number",
        special_character:"Special character",
        confirm_password :"Confirm Password",
        trade_With_virtual_funds:"Trade With Virtual Funds",
        test_strategies:"Test Strategies for Free",
        risk_free_trading:"Risk Free Trading",
        live_market_feed: "Live Market Feed",
        liquidity_from_top :"Liquidity From Top LPs",
        effective_trading:"Effective Trading Tools",
        instant_execution:"Instant Execution",
        low_commissions:"Low Commissions and Spreads",
        create_new:"Create New",
        
        /*=== enable-2fa.vue ====*/
        enable_2fa: "Enable 2 Factor Authentication",
        click_to_enable: "Click to Enable",
        
        /*=== internal-transfer.vue ====*/
        received_your_request:"We have received your request to transfer",
        from_trading_account:"from the trading account",
        to_confirm:"To confirm, kindly click on the confirmation link sent to your registered e-mail ID.",
        internal_transfer_request:"Your internal transfer request from account",
        for_amount:"for amount",
        to_account:"to account",
        was_succesfull :"was succesfull with an amount of",
        internal_transfer: "Internal Transfer",
        transfer_From: "Transfer From",
        transfer_to:"Transfer To",
        balance: "Balance",
        enter_amount: "Enter Amount",
        USE_MAX:"USE MAX",
        proceed:"Proceed",
        Internal_Transfer_ZIP:"Internal Transfer is not avaliable for ZTP account.",
        In_case_of_internal_transfer:"Note: In case of internal transfer between accounts with different base currencies, the amount transferred will be as per the prevalent market prices.",
        
        /*=== manage-account.vue ====*/
        attention :"Attention - You are about to request to delete the Trading ID",
        note_after_requesting:"Note: - After requesting, your account will be deleted from the records and you won't be able to reinstate it.",
        after_clicking:"After clicking on confirm button, you will get a confirmation link on your registered email ID to delete your trading account",
        currency: "Currency",
        Account_Type: "Account Type",
        Account_Label: "Account Label",
        Bonus: "Bonus",
        Leverage: "Leverage",
        Equity: "Equity",
        Create_Demo_Account: "Create Demo Account",
        Create_Live_Account :"Create Live Account",
        internal_transfer_CAP:"INTERNAL TRANSFER",
        web_trading:"WEB TRADING",
        add_account_label_CAP:"ADD ACCOUNT LABEL",
        change_laverage:"CHANGE LEVERAGE",
        delete_account:"Delete Account",
        reset_trading_password:"RESET TRADING PASSWORD",
        
        verifying_your_request: "Verifying your request...",
        success: "SUCCESS",
        error: "ERROR",
        
        /*=== operations-verify.vue ====*/
        we_have_received_your_request :"We have received your request to reset the Investor password. To confirm, kindly click on the confirmation link sent to your registered e-mail ID.",
        change_investor_password:"Change Investor Password Successfully.",
        reset_investor_password:"Reset Investor Password",
        investor_password:"Investor Password",
        master_password:"Master Password",
        trading_iD: "Trading ID",
        enter_new_password:"Enter New Password",
        confirm_new_password :"Confirm New Password",
        password_must_contain:"Your password must contain min. 6 characters and max 10 characters, atleast 1 number, 1 uppercase character and 1 Special character {'(!@$%*)'}",
        change_Password:"Change Password",
        
        /*=== reset-investor-pass.vue ====*/
        reset_master_password:"Reset Master Password",
        click_reset:"Click here to reset",
        password_caption:"Investor Password is the Read only password, which does not let the user trader. If you log in using Master Password,you get full access and trading rights in the account.",
    },
    auth: {
        /*=== corporate.vue ====*/
        corporate: "Corporate",
        account_type: "Account Type",
        select_account_type: "Select Account Type",
        individual: "Individual",
        name_of_company: "Name of company",
        country_of_company: "Country of company",
        select_company_country: "Select company country",
        registration: "Registration",
        email_company: "Email company",
        Password: "Password",
        min_password_length8: "The minimum password length is 8 characters and must contain at least 1 lowercase letter, 1 capital letter 1 number and 1 special character.",
        spcl_characters: "# of characters",
        lowercase_letter: "Lowercase letter",
        capital_letter: "Capital letter",
        number: "Number",
        special_character: "Special character",
        confirm_password: "Confirm Password",
        Phone_Number: "Phone Number",
        have_read: "I have read, understood and accepted the",
        terms_conditions: "Terms and Conditions",
        accept_terms_conditions: "Please accept the terms and conditions",
        given_your_residency: "Given your residency you ‘ll be onboarded with Triple A Experts Investment Services (GR) regulated by HCMC. You can view available protections and terms & conditions on our website. By clicking ",
        continue: "continue",
        triple_investment_services: "you agree to the opening of your account with Triple A Experts Investment Services (GR).",
        register: "REGISTER",
        already_have_account: "Already have an account?",
        login: "Login",
        /*=== forgot-password.vue ====*/
        confirmation_link: "A confirmation link has been sent to your registered email ID. Kindly click on the link to reset your login password.",
        ok: "OK",
        this_email_address: "This email address is not registered with us.",
        click_here: "Click here",
        create_account_now: "to create an account now",
        forgot_password: "Forgot Password",
        email_address: "Email Address",
        submit: "Submit",
        dont_have_account: "Don't have an account?",
        create_account_now_CAP: "CREATE AN ACCOUNT NOW!",
        /*=== login.vue ====*/
        client_login: "Client Login",
        remember_me: "Remember me",
        two_step_verification: "Two-step Verification",
        google_authenticator: "Please enter the one time passcode shown in the Google Authenticator app.",
        google_auth_code: "Google Auth Code",
        /*=== register.vue ====*/
        sent_an_OTP: "We've sent an OTP to",
        complete_your_registration: "Please enter it to verify and complete your registration.",
        otp: "OTP",
        Register_heading: "Register",
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        country: "Country",
        select_residence_country: "Select residence country",
        privacy_policy: "Privacy Policy",
        accept_privacy_policy: "Please accept the privacy policy",
        experts_investment_services: "Given your residency you ‘ll be onboarded with Triple A Experts Investment Services (GR) regulated by HCMC. You can view available protections and terms & conditions on our website. By clicking ",
        opening_your_account: "you agree to the opening of your account with Triple A Experts Investment Services (GR).",
        chEn_redirectmsg1: 'Based on your selection, you will be redirected to the website of OriVest (Pty) Ltd , which is registered in registered in South Africa. OriVest (Pty) Ltd falls outside the European regulatory framework, and is not in scope of the Markets in Financial Instruments Directive II (MiFID II), among others. In addition, there is no provision for an investor compensation scheme.',
		chEn_redirectmsg2: 'Before you proceed, please confirm that your decision was made independently and at your own exclusive initiative, and that no solicitation or recommendation has been made by OriVest (Pty) Ltd or any other entity within the group.',
        chEn_continue: 'Continue',
        chEn_takeback: 'Take me back',
        /*=== reset-password.vue ====*/
        login_password_change: "Your login password has been successfully changed.",
        reset_password: "Reset Password",
        reset: "Reset",
    },
    //H
    copy_trading: {
        copy_trading: "Copy Trading",
        copy_trading_header: "Earn profits by automatically copying the strategy manager's trades",
        leading_traders: "AUTOMATICALLY COPY LEADING TRADERS",
        diversified_trading: "DIVERSIFIED TRADING PORTFOLIO",
        monitor_profit: "MONITOR & PROFIT",
        copy_traders: "HOW TO COPY TRADES?",
        one: "1.",
        one_header: "Open a Live Account and make a deposit.",
        two: "2.",
        two_header: "Choose a Strategy Manager.",
        three: "3.",
        three_header: "Agree the terms and conditions.",
        four: "4.",
        four_header: "Furnish us your agreement.",
        five: "5.",
        five_header: "Earn profits by copying trades.",
        order_processing: "QUICK ORDER PROCESSING",
        end_result: "CONTROL OVER THE END RESULT",
        trading_skills: "UPGRADE YOUR TRADING SKILLS",
        start: "Start"
    },
    downloads: {
        mt_four_desktop: "MT4 Desktop",
        mt_four_android: "MT4 Android",
        mt_four_ios: "MT4 iOS",
        mt_four_web_trader: "MT4 Web Trader",
        mt_five_desktop: "MT5 Desktop",
        mt_five_android: "MT5 Android",
        mt_five_ios: "MT5 iOS",
        mt_five_web_trader: "MT5 Web Trader",
        act_trader_desktop: "Act Trader Desktop",
        act_trader_android: "Act Trader Android",
        act_trader_ios: "Act Trader iOS",
        act_web_trader: "Act Web Trader"
    },
    tools_index: {
        avail_vps: "Are you sure you want to avail VPS",
        package: "Package ?",
        yes: "Yes",
        no: "NO",
        downloads: "Downloads",
        copy_trading: "Copy Trading",
        vps: "VPS"
    },
    vps: {
        vps_plans: "VPS Plans",
        bronze: "BRONZE",
        monthly_subscription_twenty_five: "Monthly Subscription $25",
        free_deposit_five_thousand: "Get it free on deposit of $5,000 or above",
        compatible_mt_four_five_act: "Compatible with MT4, MT5 and Act",
        free_twenty_five_gb_disk_space_ram_vcpu: "Free 25 GB Disk Space | 1300 MB RAM | 1 VCPU",
        windows_linux_support: "Windows 8/10/12, Linux Supported",
        avail_now: "Avail Now",
        silver: "SILVER",
        monthly_subscription_fourty_five: "Monthly Subscription $45",
        free_on_deposit_ten_thousand: "Get it free on deposit of $10,000 or above",
        free_fifty_gb_disk_space_ram_vcpu: "Free 50 GB Disk Space | 2700 MB RAM | 2 VCPU",
        gold: "GOLD",
        monthly_subscription_eighty: "Monthly Subscription $80",
        free_on_deposit_fifteen_thousand: "Get it free on deposit of $15,000 or above",
        free_seventy_five_gb_disk_space_ram_vcpu: "Free 75 GB Disk Space | 5120 MB RAM | 3 VCPU"
    },
    ticket_details: {
        cancel_withdrawal_request: "Cancel Withdrawal Request",
        cancel_your_withdrawal_request: "Are you sure that you want to cancel you Withdrawal Request",
        process_request: "Process Request",
        open_tickets: "Open Tickets",
        back: "Back",
        ticket_number: "Ticket Number:",
        created: "Created:",
        reason: "Reason:",
        username: "Username:"
    },
    bonus: {
        request_to_avail_bonus: "Your request to avail bonus of",
        trading_id: "for the trading ID",
        click_confirmation_link: "has been received. To confirm, kindly click on the confirmation link sent to your registered e-mail ID.",
        request_to_remove_bonus: "Your request to remove bonus of",
        bonus_amount: "Your bonus amount of",
        successfully_removed_account: "has been successfully removed from account id",
        ok: "OK",
        request_to_add_bonus: "Your request to add bonus of",
        successfully: "has been successfully.",
        bonus: "BONUS",
        select_trading_id: "Select Trading ID",
        use_max: "Use Max",
        account_type: "Account Type",
        equity: "Equity",
        leverage: "Leverage",
        currency: "Currency",
        current_bonus: "Current Bonus",
        allowed_bonus: "Allowed Bonus",
        remove: "Remove",
        account_first: "Please select a account first",
        bonus_amount_base_currency: "Note: Enter Bonus Amount in the Base Currency.",
        point_one: "1. Our 100% Bonus Offer is available to all clients making a minimum deposit of USD 100 and with account leverage of up to 1:200. The maximum bonus allowed is USD 40,000 per client.",
        point_two: "2. Profit earned from trades by our bonus will be all yours. Bonus will not be taken out if you withdraw your profits.",
        point_three: "3. Bonus boosts your available margin in the account. However, your losses cannot be dipped into bonus. If the total losses on your trades exceed your own funds, system will automatically stop out the positions in your trading account without any prior notification.",
        point_four: "4. The proportionate amount of bonus would be taken out from your account if you make a withdrawal of your own funds.",
        read_understood_accepted: "I have read, understood and accepted the",
        aaafx_bonus_policy: "AAAFx Bonus Policy.",
        accept_aaafx_bonus_policy: "Please accept AAAFx bonus policy",
        proceed: "Proceed",
        no_bonus_available_account: "No bonus available for this account"
    },
    refer_earn: {
        bonus: "BONUS",
        refer_earn: "REFER AND EARN",
        refer_friend: "Refer a friend",
        earn_dollar_twenty_five: "Earn $25",
        per_friend: "per friend",
        why_refer_someone_to_us: "Why should you refer someone to us?",
        refer_someone_point_one: "1. You and your friend get the benefit of the referral bonus.",
        refer_someone_point_two: "2. A straightforward and quick procedure",
        refer_someone_point_three: "3. You both benefit from our favourable trading conditions.",
        refer_someone_point_four: "4. Earnings from referrals are limitless.",
        what_need_to_do: "Here is what you need to do:",
        what_need_to_do_point_one: "1. Share your referral link with your associates.",
        what_need_to_do_point_two: "2. Your referrals sign up using your link and start trading.",
        what_need_to_do_point_three: "3. As soon as your referral qualifies, you both get $25 each.",
        referral_list: "Your Referral List"
    },
    referral_list: {
        referrals_list: "Referrals list",
        list_of_referrals: "List of referrals to track your earnings.",
        s_no: "S.No.",
        name: "Name",
        email_id: "Email ID",
        account_stage: "Account Stage",
        deposits: "Deposits",
        volume_required: "Volume Required",
        traded_volume: "Traded Volume",
        qualified: "Qualified",
        no_data: "No data",
        payment_of_referral_bonus: "Payment of the Referral Bonus shall be done in the week subsequent to the week in which the Referral has qualified.",
        referral_bonus_paid_in_aaafx_wallet: "The Referral bonus shall be paid in the AAAFx USD wallet that the Referrer and the Referral can then either withdraw or transfer to their trading account.",
        read_all_terms_conditions: "Read all Terms and Conditions",
        here: "here",
        contact_us: "Questions? Contact us at Live Chat 24/5 or write to us at",
        customer_care: "customercare{'@'}aaafx-international.com",
        definitions: "Definitions",
        meaning_of_all_above_columns: "Here is the meaning of all the above columns for your reference:",
        name_of_your_referral: "- Name of your referral.",
        meaning_of_various_stages: "- Please see below meaning of various stages.",
        registered: "1. Registered:",
        registered_link: "Your referral has registered using your link.",
        funded: "2. Funded:",
        referral_deposited: "Your referral has deposited.",
        third_point_qualified: "3. Qualified:",
        referral_has_deposited: "Your referral has deposited and reached the required trading volume. You both are now eligible for the reward.",
        deposits_made_by_referral: "- Deposits made by your referral.",
        volume_requirement: "Volume requirement",
        volume_required_for_reward: "- The volume required for your referral to qualify for the reward.",
        volume_your_referral_traded: "- The volume that your referral has actually traded.",
        referral_qualified_for_reward: "- Whether your referral has qualified for the reward requirement or not yet.",
        referral_ib_programs: "After earning rewards on 10 referrals, you can either become an IB or continue under Refer-and-Earn program with reward of $20 each for you and your referral. You can compare the benefits and features of our Referral and IB programs"
    },
    calculators_common: {
        asset_class: "Asset Class",
        forex: "Forex",
        commodities: "Commodities",
        indices: "Indices",
        account_base_currency: "Account Base Currency",
        usd: "USD",
        gbp: "GBP",
        aud: "AUD",
        eur: "EUR",
        symbol: "Symbol",
        select_symbol: "Select Symbol",
        trade_size_in_lots: "Trade Size(in lots)",
        calculate: "Calculate"
    },
    margin: {
        margin_required: "Margin Required:",
        maximum_leverage: "Maximum Leverage:"
    },
    pip: {
        pip_value: "Pip Value:"
    },
    swap: {
        server: "Server",
        mt_four_five: "MT4/MT5",
        act_trader: "Act Trader",
        no_of_days: "Number of days",
        long_swap: "Long Swap:",
        short_swap: "Short Swap:"
    },
    //S
    dashboard:{
        select_trading_id: "Select Trading ID",
        leverage: "Leverage",
        balance: "Balance",
        equity: "Equity",
        free_margin: "Free Margin",
        pnl: "PNL",
        web_trader : "Web Trader",
        fund: "Fund",
        promotions: "Promotions",
        hundred: "100",
        bonus: "Bonus",
        avail: "Avail",
        deposit_bonus: "Deposit bonus",
        loading_initial_data: "Loading initial data",
    },
    enable_2fa:{
        title: "Google Authentication (2FA)",
        description: "To Enable Google Two-factor (2FA) Authentication, scan the QR code and enter the generated one time passcode below.",
        google_authenticator_code: "Google Authenticator Code",
        how_to_enable: "To Enable 2 Factor Authentication:",
        download: "Download",
        google_authenticator_app: "Google Authenticator App",
        on_mobile_tablet: "on your mobile/tablet.",
        scan_the : "Scan the",
        qr_code: "QR code",
        appearing_above: "appearing above",
        enter_the: "Enter the",
        passcode: "Passcode",
        appers_in_google_auth_app: "that appears in your Google Authenticator App",
        click_on_the_button: "Click on the button",
        click_to_enable: "Click to Enable",
    },
    account_security:{
        title: "Google Authentication (2FA)",
        description: "To Enable Google Two-factor (2FA) Authentication, scan the QR code and enter the generated one time passcode below.",
        google_authenticator_code: "Google Authenticator Code",
        how_to_enable: "To Enable 2 Factor Authentication:",
        download: "Download",
        google_authenticator_app: "Google Authenticator App",
        on_mobile_tablet: "on your mobile/tablet.",
        scan_the : "Scan the",
        qr_code: "QR code",
        appearing_above: "appearing above",
        enter_the: "Enter the",
        passcode: "Passcode",
        appers_in_google_auth_app: "that appears in your Google Authenticator App",
        click_on_the_button: "Click on the button",
        click_to_enable: "Click to Enable",
    },
    change_pass:{
        success_message:"Your Password has been changed successfully.",
        ok:"OK",
        change_password: "Change Password",
        existing_password: "Existing Password",
        new_password: "New Password",
        confirm_new_password: "Confirm New Password",
        note_one: "The password should contain minimum 7 and maximum 10 characters, and should include at least 1 number, 1 Uppercase and 1 special character {'(!@#$%^)'}.",
        note_two: "Please note the Profile password is different from your trading account password",
        cancel: "Cancel",
    },
    corporate_varify_step_three:{
        please_upload_file: "please upload file",
        out_of_documents: "out of 8 Documents",
        add_file: "Add file",
        max_file_size: "Maximum files size of can be uploaded up to"
    },
    corporate_varify:{
        corporation_info: 'Corporation Info',
        account_creation: "Account Creation",
        verification: "Verification",
        deposit: "Deposit",
        select_platform: "Select Platform",
        select_account_type: "Select Account Type",
        select_leverage: "Select Leverage",
        select_base_currency: "Select Account Base currency",
        select_currency: "Select Currency",
        password: "Password",
        pass_length_alert: "The minimum password length is 5 characters and must contain at least 1 lowercase letter, 1 capital letter 1 number and 1 special character.",
        of_characters: "of characters",
        lowercase_letter: 'Lowercase letter',
        capital_letter : "Capital letter",
        number: "Number",
        special_character : "Special character",
        confirm_password: "Confirm Password",
        create_account : "Create Account",
    },
    corporation_info:{
        name_of_company: "Name of company",
        country_of_company: "Country of company",
        select_company_country: "Select company country",
        registration: "Registration",
        submit: "SUBMIT",
    },
    profile:{
        personal_details: "Personal Details",
        uploaded_documents: "Uploaded Documents",
        no_documents_yet: "No Documents Yet",
    },
    questions:{
        financial_details: "Financial Details",
        sub_heading_one: "Total Estimated Annual Income",
        select_annual_income: "Select Annual Income",
        sub_heading_two: "Total Estimated Net Worth",
        sub_heading_two_desc: "Total assets minus total liabilities of an individual or a company.",
        select_net_worth:"Select Net Worth",
        sub_heading_three: "Industry of Occupation",
        select_occupation: "Select Occupation",
        sub_heading_four: "Enter Other Occupation",
        sub_heading_five: "Sources of Funds",
        sub_heading_six: "Enter Other Sources of Funds",
        sub_heading_seven: "US FATCA Reportable Person",
        sub_heading_eight: "Country/Jurisdiction of tax residence",
        select_residence_country: "Select residence country",
        sub_heading_nine: "Do you have TIN Number?",
        sub_heading_ten: "Enter the TIN Number",
        sub_heading_eleven: "If no TIN available enter Reason",
        select_reasons: "Select Reasons",
        enter_reason: "Enter Reason",
        submit: "Submit",
        dear: "Dear",
        message_one: "Based on the information you have provided, it appears that you are a US resident for tax purposes.",
        message_two: "Please note that due to our Regulatory Compliance, AAAFx is not able to accept a client who is a U.S. resident for tax purposes.",
        message_three: "We thank you in advance for your understanding.",
        message_four: "Sincerely yours,",
        message_five: "AAAFx",
        close: "Close",
    },
    verify:{
        account_creation: "Account Creation",
        financial_details: "Financial Details",
        verification: "Verification",
        deposit: "Deposit",
        select_platform: "Select Platform",
        select_account_type: "Select Account Type",
        select_leverage: "Select Leverage",
        select_base_currency: "Select Account Base currency",
        select_currency: "Select Currency",
        password: "Password",
        pass_message_one: "The minimum password length is 5 characters and must contain at least 1 lowercase letter, 1 capital letter 1 number and 1 special character.",
        pass_message_two: "The minimum password length is 8 characters and must contain at least 1 lowercase letter, 1 capital letter 1 number and 1 special character.",
        of_characters: "of characters",
        lowercase_letter: "Lowercase letter",
        capital_letter: "Capital letter",
        number: "Number",
        special_character: "Special character",
        confirm_password: "Confirm Password",
        create_account: "Create Account",
        doc_message_one: "The documents that you submitted have been rejected by automatic verification process. A ticket regarding the same has been created where you can reupload your documents for us to manually verify the documents if you wish so.",
        view_ticket: "View Ticket",
    },
    verify_quest_bkp:{
        account_creation: "Account Creation",
        questionnaire: "questionnaire",
        verification: "Verification",
        deposit:"Deposit",
        select_platform: "Select Platform",
        select_account_type: "Select Account Type",
        select_leverage: "Select Leverage",
        select_base_currency: "Select Account Base currency",
        select_currency: "Select Currency",
        password: "Password",
        pass_length_alert: "The minimum password length is 5 characters and must contain at least 1 lowercase letter, 1 capital letter 1 number and 1 special character.",
        of_characters: "of characters",
        lowercase_letter: "Lowercase letter",
        capital_letter: "Capital letter",
        number: "Number",
        special_character: "Special character",
        confirm_password: "Confirm Password",
        create_account: "Create Account",
        doc_message_one: "The documents that you submitted have been rejected by automatic verification process. A ticket regarding the same has been created where you can reupload your documents for us to manually verify the documents if you wish so.",
        view_ticket: "View Ticket",
    },
    close_ticket:{
        heading: "Closed Tickets",
        create_request: "CREATE REQUEST",
        open_tickets: "OPEN TICKETS",
        ticket_number: "Ticket Number",
        trading_id: "Trading ID",
        status: "Status",
        subject: "Subject",
        created: "Created",
        closed: "Closed",
        action: "Action",
        view_ticket: "View Ticket",
        no_tickets_found: "No tickets found",
    },
    open_ticket:{
        heading: "Open Tickets",
        create_request: "CREATE REQUEST",
        open_tickets: "OPEN TICKETS",
        closed_ticket: "Closed Tickets",
        ticket_number: "Ticket Number",
        trading_id: "Trading ID",
        status: "Status",
        subject: "Subject",
        created: "Created",
        action: "Action",
        view_ticket: "View Ticket",
        no_tickets_found: "No tickets found",
    },
    request_call:{
        success_message:"Your request for a call back has been received. Our team will contact you shortly.",
        ok: "OK",
        request_call_back:"Request Call Back",
        first_name: "First Name",
        last_name: "Last Name",
        email_id: "Email ID",
        phone_number: "Phone Number",
        timezone: "Timezone",
        date: "Date",
        preferred_time: "Preferred Time",
        department: "Department",
        select_department: "Select department",
        new_accounts: "New Accounts",
        deposits: "Deposits",
        withdrawals: "Withdrawals",
        partnership: "Partnership",
        technical_support: "Technical Support",
        message: "Message",
        send_request: "Send Request",
    },
    support_page:{
        success_message:"A Support Ticket for you has been successfully created. You can track it under Open Tickets.",
        ok:"OK",
        support: "Support",
        create_req:"CREATE REQUEST",
        open_tickets:"OPEN TICKETS",
        closed_tickets: "CLOSED TICKETS",
        otp_msg:"We've sent a OTP to your registered email. Please enter it to verify support ticket request.",
        otp: "OTP",
        submit: "Submit",
        reason: "Reason",
        select_a_reason: "Select a reason",
        trading_id: "Trading ID",
        select_trading_account: "Select Trading Account",
        subject: "Subject",
        trade_order_id: "Trade Order ID",
        time_of_trade_opening: "Time of Trade Opening",
        time_of_trade_closing: "Time of Trade Closing",
        instrument_traded: "Instrument Traded",
        type_of_trade: "Type of Trade",
        select_trade_type: "Select Trade type",
        details_of_the_issue: "Details of the issue",
        refund_claim_amount: "Refund Claim Amount",
        message: "Message",
        note: "NOTE",
        file_attachments: "File Attachments",
        file_size_msg: "Size of the document should not be more than 1MB",
        file_format_msg: "File format (jpeg or pdf) only",
        lowercase_note: "Note",
        note_desc: "In case of any error while doing any account operation, please attach the screenshot also while creating ticket",
        create_support_request: "Create Support Request",
    },
    become_ib:{
        heading: "Introducing Broker",
        description: "Boost Your earnings with our IB Program. <br /> Get your dedicated link, share it with your friends and earn commissions whenever they trade.",
        sub_heading: "We offer made two categories of IB programs:",
        point_one: "Standard IB Program- Straightaway get 20% of our commission earnings from your clients. This is useful for a beginner IB who wants to start afresh or can start to bring a limited volume of clients to us.",
        point_two: "Advanced IB Program- This is a highly rewarding and customized IB program for our bigger IBs. This is useful for someone with a substantial client base who can bring in a larger volume.",
        note_one: "You can move from Standard IB Program to the Advanced IB Program, once you have made your network large enough.",
        earn_with: "Earn with",
        zero_investment_or: "zero investment or",
        experience: "experience",
        weekly_ib: "Weekly IB",
        commissions: "Commissions",
        payouts: "payouts",
        unlimited: "Unlimited",
        earnings: "earnings",
        potential: "potential",
        sub_cont_point_four: "Highly customized and rewarding advanced IB Program",
        ultra_fast: "Ultra fast",
        withdrawals_of_ib: "withdrawals of IB",
        commission: "commission",
        easy_user: "Easy user",
        interface_of: "interface of",
        ib_portal: "IB Portal",
        dedicated: "Dedicated",
        account: "Account",
        manager: "Manager",
        helpful_and: "Helpful and",
        free_marketing: "Free Marketing",
        material: "Material",
        become_an_ib: "Become an IB",
    },
    pamm_acct:{
        title:"PAMM ACCOUNT",
        description_one: "PAMM (Percentage Allocation Management Module) is a managerial account in which the manager executes trades in all of its sub-accounts. The manager and the Investors are free to choose a performance fee structure, and we’ll take care of putting it in place.",
        description_two: "AAAFx provides highly flexible and customized PAMM trading solutions.",
        sub_title: "How to enroll as PAMM Manager",
        sub_Point_one: "Your PAMM Manager account can be opened once you have at least four investors with a total deposit of $5,000 or more.",
        sub_Point_two: "Simply register as an IB to become a PAMM Manager with us. Get your clients registered using your IB link, meet the first condition above.",
        sub_Point_three: "Reach out to us via Live Chat or email us at",
        sub_Point_four: "Start earning IB commissions in addition to the PAMM Performance Fees.",
        minimul_investment: "MINIMAL INVESTMENT",
        ease_of_access: "EASE OF ACCESS",
        ultimate_trading_conditions: "ULTIMATE TRADING CONDITIONS",
        trade_security: "TRADE SECURITY",
        request_pamm: "Request PAMM",
    },
    add_payment_methods:{
        success_message: "Your payment method has been added successfully. You can track it under Open Tickets.",
        ok: "OK",
        otp_message: "We've sent a OTP to your registered email. Please enter it to verify support ticket request.",
        otp: "OTP",
        submit: "Submit",
        page_heading: "Add Payment Methods",
        select_payment_method: "Select Payment Method",
        select_method: "Select Method",
        bank: "Bank",
        credit_card: "Credit Card",
        crypto: "Crypto",
        select_crypto_currency: "Select Crypto Currency",
        select_crypto: "Select Crypto",
        btc: "BTC",
        eth: "ETH",
        usdt: "USDT",
        usdc: "USDC",
        add_your_bank_details: "Add Your Bank Details",
        bank_name: "Bank Name",
        account_name: "Account Name",
        account_number: "Account Number",
        country: "Country",
        select_country: "Select country",
        iban: "IBAN",
        iban_note: "My Bank Doesn’t issue IBAN",
        swift: "Swift",
        bic: "BIC",
        sort_code: "Sort Code",
        bank_address: "Bank Address",
        upload_your_bank_statement: "Upload Your Bank Statement",
        upload_doc_info_one: "Size of the document should not be more than 1MB",
        upload_doc_info_two: "File format (jpeg or pdf) only",
        note: "Note",
        note_msg: "In case of any error while doing any account operation, please attach the screenshot also while creating ticket",
        create_support_request: 'Create Support Request',
        add_your_card_details: "Add Your Card Details",
        creadit_card_number: "Creadit Card Number",
        month: "Month",
        zero_one: "01",
        zero_two: "02",
        zero_three: "03",
        zero_four: "04",
        zero_five: "05",
        zero_six: "06",
        zero_seven: "07",
        zero_eight: "08",
        zero_nine: "09",
        ten: "10",
        eleven: "11",
        twelve: "12",
        year: "Year",
        two_thousand_twenty: "2020",
        two_thousand_twentyone: "2021",
        two_thousand_twentytwo: "2022",
        two_thousand_twentytree: "2023",
        two_thousand_twentyfour: "2024",
        two_thousand_twentyfive: "2025",
        two_thousand_twentysix: "2026",
        two_thousand_twentyseven: "2027",
        two_thousand_twentyeight: "2028",
        two_thousand_twentynine: "2029",
        two_thousand_thirty: "2030",
        cvv: "CVV",
        varification_msg: "We require the following for the card verification",
        varification_msg_one: "Color copy of the front side of the card, showing: full name, expiration date, Bank name/logo, first 4 and last 4 digits of the credit card number hiding the middle 8 digits.",
        upload_supporting_document: "Upload Supporting Document",
        varification_msg_two: "Color copy of the back side of the card hiding the CVV security code. The back copy should shown the sign of the holder",
        add_selected_crypto_address: "Add Selected Crypto Address",
        address: "Address",
    },
    deposit:{
        account_type: "Account Type",
        select_type: "Select type",
        live: "Live",
        trading_account: "Trading Account",
        select_trading_account: "Select Trading Account",
        balance: "Balance",
        fund: "FUND",
        amount: "Amount",
        region: "Region",
        currencies: "Currencies",
        processing_time: "Processing Time",
        action: "Action",
        view_more: "View More",
        currency: "Currency",
        zar: "ZAR",
        swift_code: "Swift Code",
        beneficiarys_name: "Beneficiarys Name",
        beneficiarys_name_des: "SIKHULA VENTURE CAPITAL (PTY) LTD",
        account_number: "Account Number",
        user_account_number: "62928423269",
        bank_address: "Bank Address",
        bank_address_info: "Mybranch Forum 1, 4th Fl, 33 Hoofd Str, Braampark",
        dixipay: "Dixipay",
        bank_name: "Bank Name",
        bank_name_info: "DIXIPAY LTD",
        swift_code_info: "DIXPGB21",
        beneficiarys_name_info: 'Alpha Global Limited',
        iban: "IBAN",
        iban_no: "GB78DIXP00997890200462",
        eur: "EUR",
        city: "City",
        city_info: "London",
        country: "Country",
        country_info: "United Kingdom",
        dixipay_note: "Dixipay accepts only deposits. in EURO",
        you_can_deposit: "You can deposit",
        you_can_deposit_msg: "in the following address and equivalent amount in the selected account currency will be added after conversion",
        copy: "Copy",
        done: "Done",
        network_msg: "ERC-20 network (USDT, USDC, ETH) is supported, use of any other network will not reach our end.",
    },
    fund_index: {
        add_funds: "Add Funds",
        cancel: "Cancel",
        ok: "OK",
        your_request_to_add: "Your request to add",
        to_your_demo_account_number: "to your Demo Account Number",
        has_been_successfully_completed: "has been successfully completed",
        your_request_to_withdraw: "Your request to withdraw",
        from_the_trading_id: "from the trading ID",
        has_been_received: "has been received",
        click_to_proceed_withdrawal: "Kindly click on the confirmation link sent to your registered email ID to process the withdrawal",
        has_been_successfully: "has been Successfully",
        your_request_to_add_usd: "Your request to add USD",
    },
    request_verify: {
        verifying_your_request: "Verifying your request",
        success: "SUCCESS",
        go_to_transactions: "Go to Transactions",
        error: "ERROR",
    },
    transactions: {
        list_of_transactions: "List of Transactions",
        deposits: "Deposits",
        withdrawals: "Withdrawals",
        bonus: "Bonus",
        deposit_transactions: "Deposit Transactions",
        filter_by: "Filter by",
        select_trading_id: "Select Trading ID",
        all: "ALL",
        date: "Date",
        account_id: 'Account ID',
        currency: "Currency",
        payment_mode: "Payment Mode",
        deposit_amount: "Deposit Amount",
        status: 'Status',
        no_deposits_yet: "No deposits yet",
        withdrawal_mode: "Withdrawal Mode",
        withdrawal_amount: "Withdrawal Amount",
        action: "Action",
        view_more : "View More",
        no_withdrawals_yet: "No withdrawals yet",
        bonus_amount: "Bonus Amount",
        pending : "Pending",
        no_bonus_transactions_yet: "No bonus transactions yet",
        deposit_currency: "Deposit Currency",
        account_currency: 'Account Currency',
        address: 'Address',
    },
    withdrawal: {
        kyc_req_msg: "It's mandatory to complete KYC prior to requesting a withdrawal. Please submit a proof of address using a support ticket",
        Click_here: "Click here",
        or_email_to: 'or email to',
        with_step_heading: "The following Address Proofs are accepted",
        one: "1",
        two: "2",
        three: "3",
        with_step_one: "Utility Bill",
        with_step_two: "Bank Statement",
        with_step_three: "Government-Issued Tax Document",
        note: "Note",
        note_info: "The proof of address is required to be no older than 4 months",
        ok: "OK",
        enable_2fa_msg: "It's mandatory to enable the 2FA for raising withdrawal request. Please click on following button",
        click_to_enable: "Click to Enable",
        select_trading_id: "Select Trading ID",
        account_id: "Account ID",
        account_type: "Account Type",
        platform: 'Platform',
        leverage: "Leverage",
        currency: "Currency",
        free_margin: "Free Margin",
        note_info_two: "Enter Withdrawal amount in the Base Currency of your TradingAccount.",
        amount: "Amount",
        mode_of_payment: "Mode of Payment",
        create_transaction: "Create Transaction",
        cancel: "Cancel",
        add_payment_method: "Add Payment Method",
        no_amount_available: "No Amount is available in this account",
    },
    //components -> Shared
    account_dropdown:{
        select_account: "Select account",
    },
    footer: {
        legal_information: "Legal Information",
        legal_information_info: "Sikhula Venture Capital (Pty) Ltd. is authorized and regulated by the South African Financial Sector Conduct Authority (FSCA No. 2017/315029/07).",
        risk_warning: "Risk Warning",
        risk_warning_info: "Trading spot currencies involves substantial risk and there is always the potential for loss. Your trading results may vary. Because the risk factor is high in the foreign exchange market trading, only genuine “risk” funds should be used in such trading. If you do not have the extra capital that you can afford to lose, you should not trade in the foreign exchange market. No “safe” trading system has ever been devised, and no one can guarantee profits or freedom from loss.",
    },
    header: {
        welcome: "Welcome", 
        profile: 'Profile',
        request_callback: "Request Callback",
        support_ticket: "Support Ticket",
        change_password: "Change Password",
        logout: "Logout",
    },
    pagination: {
        total_records: "Total Records", 
    },
    side_bar: {
        dashboard: "Dashboard",
        manage_accounts: "Manage Accounts",
        fund: "Fund",
        bonus: "Bonus",
        become_a_partner: "Become a Partner",
        tools: "Tools",
        bonus_and_promotions: 'Bonus & Promotions',
    },
    success_box: {
        otp_varify: "Please enter the 6 digit One-Time Pin shown in the Google Authenticator app.",
        cancel: "Cancel",
        submit: 'Submit',
        trouble_with_2fa: "Having Trouble with your Two-Factor Authentication Code?",
        click_varify_with_email: "Click Here To Verify With Email",
        or: "OR",
        click_here: "Click here",
        to_enable_2fa: "to enable your 2FA and complete your request",
        take_me_back: "Take me back",
    },
    tost_message: {
        varify_acc: "Please verify your account to create live account",
        click_to_begin: "Click to begin verification process",
    },
    proof_residence_alert: {
        you_have: "You have",
        days_left_for_proof: "days left to submit the proof of residence.",
        click_here: "Click here",
        to_upload: "to upload",
    },
    closed_trades: {
        login: "Login",
        order: "Order",
        symbol: "Symbol",
        volume: "Volume",
        open_price: "Open Price",
        open_time: "Open Time",
        commission: "Commission",
        type: 'Type',
        sl: "SL",
        tp: "TP",
        close_price: 'Close Price',
        close_time: 'Close Time',
        swap: 'Swap',
        pnl: "PNL",
        comment: 'Comment',
        no_record_found: "No record found",
    },
    open_trade: {
        order: 'Order',
        symbol: 'Symbol',
        type: 'Type',
        volume: "Volume",
        open_price: "Open Price",
        pnl: "PNL",
        no_record_found: "No record found",
    },
}